import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withCompetency, withTheme} from '/provider/ThemeProvider';
import {useTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {withHOC} from '/util/hoc.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './QualifiedIncentiveTripPath.style';
interface QualifiedIncentiveTripPathProps {
  item: {
    path?: number | null;
  };
  getTheme: (path: string) => string;
}

const QualifiedIncentiveTripPath: React.FC<QualifiedIncentiveTripPathProps> = ({
  item = {},
  getTheme = () => '',
}) => {
  const {tt} = useTranslation('report.record.qualifiedIncentiveTripPath');
  const path = get(item, 'path', null);
  const iconStyle = {
    ...styles.icon,
    color: getTheme('competency.textColor.color'),
  };
  return (
    path && (
      <View style={styles.container}>
        <Icon name="circle-checkmark-filled" style={iconStyle} />
        {tt(
          'incentivePath',
          generateComponentCallback({
            component: (
              <Text
                style={styles.text}
                variant="body"
                emphasis="medium"
                {...testProperties(Reports.reportItPath)}>
                Path {{path}}
              </Text>
            ),
          }),
        )}
      </View>
    )
  );
};

export {QualifiedIncentiveTripPath};
export default withHOC(withTheme, withCompetency)(QualifiedIncentiveTripPath);
